<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Elomark User Types</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button v-if="abilities.can('create', 'user-types')"
            icon="add"
            @click="addUserType"
            color="danger"
            type="border"
            >Add</vs-button
          >
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
          <div class="p-1">
            <span>Search: </span>
          </div>

          <UserTypeAutocomplete
            :key="companySearchComponentKey"
            class="searchbox"
            :list="searchUserType"
            :searchOn="'usertype'"
            @event-name="handleChildEvent"
          ></UserTypeAutocomplete>
          <vs-icon
            class="pl-5 pointer"
            icon="cancel"
            @click="resetUserType"
            size="small"
          ></vs-icon>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
           <vs-button
                    class="ml-20"
            icon="refresh"
            @click="resetAll"
            color="primary"
            >Reset</vs-button
          >

          <!-- <vs-pagination :total="Math.ceil(total/per_page)" v-model="currentx"></vs-pagination> -->
        </vs-col>
      </vs-row>

      <vs-table
        class="mb-10"
        @search="handleSearch"
        @sort="handleSort"
        v-model="selected"
        stripe
        :data="usertypes"
      >
        <template slot="thead">
          <!-- <vs-th sort-key="s_no">S No.</vs-th> -->
          <vs-th sort-key="usertype">User Type</vs-th>
          <vs-th sort-key="usertype_description">Description</vs-th>
          <vs-th sort-key="status">status</vs-th>
          <vs-th sort-key="actions">Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td> -->
            <vs-td :data="data[indextr].usertype">
              {{ data[indextr].usertype }}
            </vs-td>
            <vs-td :data="data[indextr].usertype_description">
              {{ data[indextr].usertype_description }}
            </vs-td>
            <vs-td :data="data[indextr].status">
              {{ data[indextr].status }}
            </vs-td>
            <vs-td :data="data[indextr].actions">
              <vs-icon v-if="abilities.can('read', 'user-types')"
                class="ml-10 removeButton"
                @click="viewUserType(data[indextr].id)"
                color="success"
                icon="visibility"
              ></vs-icon>
              <vs-icon v-if="abilities.can('update', 'user-types')"
                class="ml-10 removeButton"
                @click="editUserType(data[indextr].id)"
                color="success"
                icon="edit"
              ></vs-icon>
              <vs-icon v-if="abilities.can('delete', 'user-types')"
                class="ml-10 removeButton"
                @click="confirmDeleteUserType(data[indextr].id)"
                color="success"
                icon="delete"
              ></vs-icon>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <template>
        <vs-pagination
          :total="Math.ceil(total / per_page)"
          v-model="currentx"
        ></vs-pagination>
      </template>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import moduleUserTypeManagement from "@/store/usertype-management/moduleUserTypeManagement.js";
import UserTypeAutocomplete from "@/components/autocomplete/UserTypeAutocomplete.vue";
import vSelect from "vue-select";
export default {
  data: () => ({
    abilities : null,
    companySearchComponentKey: 0,
    selected: [],
    log: [],
    usertypes: [],
    selected_id: null,
    currentx: 1,
    total: 0,
    clientUserTypeList: ['y','n'],
    elomarkUserTypeTypes: [],
    size_per_page: [10, 20, 50, 100, 500],
    per_page: 10,
    paginationAttr: {
      page_no: 1,
      per_page: 10
    }
  }),
  components: {
    UserTypeAutocomplete,
    "v-select": vSelect,
    moduleUserTypeManagement
  },
  watch: {
    currentx: function(val) {
      this.paginationSetPageSize();
    },
    per_page: function(val) {
      this.paginationSetPageSize();
    },
  },
  methods: {
    resetAll(){
       this.resetUserType()

    },
    resetUserType() {
      this.fetchUserTypes();
      this.companySearchComponentKey += 1;
    },
    paginationSetPageSize() {
      this.paginationAttr = {
        page_no: this.currentx,
        per_page: this.per_page
      };
      this.fetchUserTypes();
    },
    searchUserType(inputValue) {
      return this.$store
        .dispatch("usertypesManagement/searchUserType", inputValue)
        .then(response => {
          if (response) {
            let data = response.data;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name: data[property].usertype
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    addUserType() {
      this.$router.push({ path: "/usertype/add" });
    },
    handleSearch(searching) {
      console.log(`The usertype searched for: ${searching}`);
    },
    handleSort(key, active) {
      console.log(`the usertype ordered: ${key} ${active}`);
    },
    viewUserType(id) {
      this.$router.replace("/usertype/" + id);
    },
    editUserType(id) {
      this.$router.replace("/usertype/edit/" + id);
    },
    handleChildEvent() {
      this.usertypes = moduleUserTypeManagement.state.usertypes.datas;
    },
    confirmDeleteUserType(id) {
      this.selected_id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete User Type`,
        accept: this.deleteUserType,
        acceptText: "Delete"
      });
    },
    deleteUserType() {
      this.$store
        .dispatch("usertypesManagement/removeUserType", this.selected_id)
        .then(res => {
          if (res.data.status == "success") {
            this.fetchUserTypes();
            this.showDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "User Type Deleted",
        text: "The User was successfully deleted"
      });
    },
    fetchUserTypes() {
      this.$store
        .dispatch(
          "usertypesManagement/fetchAllUserTypes",
          this.paginationAttr
        )
        .then(res => {
          this.usertypes =
            moduleUserTypeManagement.state.usertypes.datas;
          this.total = moduleUserTypeManagement.state.usertypes.total;
          this.per_page =
            moduleUserTypeManagement.state.usertypes.per_page;
        })
        .catch(err => {
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  },
  mounted() {
    this.fetchUserTypes();
  },
  created() {
    var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });    
    if (!moduleUserTypeManagement.isRegistered) {
      this.$store.registerModule(
        "usertypesManagement",
        moduleUserTypeManagement
      );
      moduleUserTypeManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-usertypes
  .con-btns-usertype
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-rolex
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
